import React from "react";
import { ShapeTile } from "./ShapeTile";

export const MatrixGrid = ({ grid }) => (
  <div
    data-testid="question-matrix-grid"
    className="inline-grid grid-cols-3 gap-2 p-3 rounded-2xl bg-[#0B0F17] border border-white/10"
  >
    {grid.map((tile, i) => (
      <div
        key={`cell-${i}-${tile ? `${tile.kind}${tile.n ?? ""}${tile.sides ?? ""}${tile.rot ?? ""}${tile.fill ?? ""}` : "blank"}`}
        className="flex items-center justify-center w-20 h-20 sm:w-24 sm:h-24 rounded-lg bg-[#131B2A] border border-white/5"
      >
        <ShapeTile tile={tile} size={72} />
      </div>
    ))}
  </div>
);
